import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AccordionItemBasic } from '../../shared/components/accordion/accordion-item.model';

@Injectable({
  providedIn: 'root'
})
export class SaibaMaisService {
  private apiUrl: string = environment.apiUrl;

  constructor(private http: HttpClient) { }

  getAccordionItems(page = 1, size = 100): Observable<AccordionItemBasic[]> {
    const url = `${this.apiUrl}/cms/faqs`;
    const params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString());

    return this.http.get<{ data: AccordionItemBasic[] }>(url, { params }).pipe(
      map(response => response.data)
    );
  }
}
